import { useTranslation } from "react-i18next";
import { featuredProducts } from "@/mocks/homeData";

export default function FeaturedProducts() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="mb-12 md:mb-16">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-light text-foreground-950 leading-tight">
            {t("products.heading")}
          </h2>
          <p className="text-sm text-foreground-400 mt-3">
            {t("products.subtitle")}
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featuredProducts.map((product, idx) => (
            <div
              key={product.name}
              className="rounded-3xl overflow-hidden bg-background-50 border border-background-200/70 flex flex-col group"
            >
              {/* Image */}
              <div className="relative w-full aspect-square overflow-hidden bg-background-100">
                <img
                  src={product.image}
                  alt={product.name}
                  title={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>

              {/* Info */}
              <div className="p-5 flex flex-col items-center gap-3 flex-1">
                <h3 className="text-base font-semibold text-foreground-900 text-center leading-snug">
                  {product.name}
                </h3>
                <span className="text-2xl font-bold text-foreground-950">
                  {product.price}
                </span>

                {/* CTA Button */}
                <a
                  href={product.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className={`w-full text-center py-3 px-6 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap mt-auto ${
                    idx === 0
                      ? "bg-foreground-950 text-background-50 hover:bg-foreground-800"
                      : "border border-foreground-200 text-foreground-800 hover:bg-foreground-50"
                  }`}
                >
                  {t("products.viewOnSheet")} →
                </a>

                <span className="text-[11px] text-foreground-300">
                  {t("products.redirectNote")}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}